import React, { useEffect, useState } from 'react';
import AppRouter from './AppRouter';
import stores from '@stores/index';

import Http from '@helpers/Http';
import { Api } from '@apis/client';
import { isCubeApp, appCode, commandMessage } from '@helpers/Constants';
import NativeInterface  from '@helpers/NativeInterface';
import Filter from '@helpers/Filter';
import pageConfig from '@config/pageConfig';

// import vConsole from 'vconsole';
// new vConsole();

const App = () => {
  const [loading, setLoading] = useState(true);
  const initAppByEntrance = async () => {
    //入口参数流程
    //1.sessionStorage中有fromSeewoUC标识表示是希沃登录，需进行身份验证
    //2.判断是否在魔方app环境中，如果是，需要根据token 获取用户信息
    if(sessionStorage.getItem('fromSeewoUC') === 'y') {
      getUserInfo(true);
    }else {
      //如果是单页入口进入时，根据path 判断 路由中是否需要auth 校验，若auth为false, 直接进入
      const pathname = window.location.pathname;
      let path = '';
      if(pathname) {
        const pathnameArr = pathname.split('/');
        path = pathnameArr[pathnameArr.length - 1];
        if(path) {
          const paths = Object.values(pageConfig);
          const checkRouterAuth = paths.find(i => i.path === ('/' + path));
          if(!checkRouterAuth?.auth) {
            return setLoading(false);
          }
        }
      }
      let token = '';
      if (isCubeApp()) { // 魔方app内嵌webview的情况
        const data = await NativeInterface.postMessage(commandMessage.getToken);
        token = data?.data.token;
      }else { //普通webview中可使用params上的token参数
        const params: any = Filter.urlParams(window.location.search);
        if(params?.token) {
          token = params?.token;
          // document.cookie = 'x-auth-token=' + token + ';path=/';
        }
      }
      getUserInfoByToken(token);
    }
  }
  const getUserInfoByToken = async (token: string) => {
    document.cookie = 'x-auth-token=' + token + ';path='+ PUBLIC_URL;
    const { data: userInfo } = await Http.post(Api.GetUserInfo,
      { token, appCode },
      { btnEvent: isCubeApp() ? () => {
        NativeInterface.postMessage(commandMessage.closeContainer);
      } : null }
    );
    stores.user.setUserInfo({ ...userInfo, token});
    setLoading(false);
  }

  const getUserInfo = async (fromSeewoUC: boolean) => {
    let userInfo = null;
    if(fromSeewoUC) {
      const data: any = await Http.ucLogin();
      userInfo = { ...data.seewoUser, token: data?.token, loginFromUC: data.loginFromUC };
    }
    stores.user.setUserInfo(userInfo);
    document.cookie = 'x-auth-token=' + userInfo?.token + ';path=' + PUBLIC_URL;

    setLoading(false);
    //上报用户登录态
    await Http.post(Api.PostLoginInfo, { appCode: 'seewo-cube-h5' });
  }

  useEffect(() => {
    console.log('进入应用');
    initAppByEntrance();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if(loading) {
    return null;
  }
  return(
    <>
      <AppRouter />
    </>
  );
}

export default App;